// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__VqIb2","contentWrapper":"styles_contentWrapper__nd2Ll"};